import React, { useState, useEffect } from 'react'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import IndicatorsPool from '../../js/IndicatorsPool';
import Translations from '../../js/Translations';
import { store } from '../../stores/store';

import './IndHistoryChart.css'


const IndHistoryChart = ({indId, unit}) => {

  const chartData = []
  let val_key = store.t("indicator_history_chart_value")

  let indicator = IndicatorsPool.getIndicator(indId)

  let precision = indicator.precision
  var allVals = store.allIndValuesHistory
  allVals.forEach((vals, index) => {

    if (index === 0) return // NOTE : on ne veut pas l'année 0

    let val = vals[indId]
    if(val === undefined) return


    let curveObj = {
      year: store.t("year") + " " + index,
      [val_key]: parseFloat(val)
    }
    chartData.push(curveObj)
  })

  function formatter(val) {
    let roundedval = IndicatorsPool.roundValue(val, precision)
    return <span dangerouslySetInnerHTML={{__html: roundedval + (unit ? " " + unit : "") }} />
  }

  return (
    <div className="IndHistoryChart">
      <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData} margin={{ top: 25, right: 5, bottom: 5, left: 25 }}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey="year"/>
            <YAxis tickFormatter={val => IndicatorsPool.roundValue(val, precision)} />
            <Tooltip separator={Translations.chartSeparator}  formatter={formatter} />
            <Line dataKey={val_key} stroke="#7B9EB7" strokeWidth="1" activeDot={{r: 8}}/>
          </LineChart>
        </ResponsiveContainer>
    </div>
  );
};

export default IndHistoryChart;
